var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-progress-wrapper"},[_c('van-progress',{attrs:{"percentage":_vm.percentage,"show-pivot":false,"stroke-width":8,"color":"var(--progress-color)"}}),_c('div',{staticClass:"percentage"},[_vm._v(" "+_vm._s(_vm.percentage)+"% ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }